import styled, { css } from 'styled-components';
import { hideVisually, transparentize } from 'polished';
import Icon from '../Icon';
export var Wrapper = styled.div.withConfig({
  displayName: "elements__Wrapper",
  componentId: "v4xauq-0"
})(["width:100%;input{", "}"], hideVisually());
export var StyledCheckbox = styled.div.withConfig({
  displayName: "elements__StyledCheckbox",
  componentId: "v4xauq-1"
})(["display:flex;justify-content:center;align-items:center;min-width:1.6rem;height:1.6rem;margin-right:1.2rem;color:", ";background:", ";border:1px solid ", ";border-radius:", ";box-shadow:inset 0 0.2rem 0 0 ", ";transition:all 150ms;&.checked{background:", ";", "{visibility:visible;}}input:focus + &{box-shadow:0 0 0 2px ", ";}", "{visibility:hidden;}"], function (_ref) {
  var palette = _ref.theme.palette;
  return palette.white;
}, function (_ref2) {
  var palette = _ref2.theme.palette;
  return palette.white;
}, function (_ref3) {
  var palette = _ref3.theme.palette,
      isChecked = _ref3.isChecked;
  return isChecked ? palette.primary.dark : palette.lightGrey;
}, function (_ref4) {
  var dimensions = _ref4.theme.dimensions;
  return "".concat(dimensions.radiusInt, "rem");
}, function (_ref5) {
  var palette = _ref5.theme.palette;
  return palette.whiteOpacity(0.1);
}, function (_ref6) {
  var palette = _ref6.theme.palette;
  return "".concat(palette.primary["default"], " linear-gradient(0deg, ").concat(palette.whiteOpacity(0), " 0%, ").concat(palette.whiteOpacity(0.1), " 100%)");
}, Icon, function (_ref7) {
  var palette = _ref7.theme.palette;
  return transparentize(0.6, palette.primary["default"]);
}, Icon);
export var Label = styled.label.withConfig({
  displayName: "elements__Label",
  componentId: "v4xauq-2"
})(["display:flex;align-items:center;cursor:pointer;position:relative;color:", ";", ";", ";"], function (_ref8) {
  var palette = _ref8.theme.palette;
  return palette.spaceGrey;
}, function (_ref9) {
  var isDisabled = _ref9.isDisabled;
  return isDisabled && css(["opacity:0.4;cursor:not-allowed;"]);
}, function (_ref10) {
  var isChecked = _ref10.isChecked;
  return isChecked && css(["color:", ";font-weight:", ";"], function (_ref11) {
    var palette = _ref11.theme.palette;
    return palette.primary["default"];
  }, function (_ref12) {
    var fonts = _ref12.theme.fonts;
    return fonts.weight.thick;
  });
});